export const productDetails = {
	title: "Details",
	getButtonContent: "GET",
	reviewsLabel: "Reviews",
};
